<template>
  <main :class="{ login: authenticated === false }">
    <top-nav v-if="authenticated"/>
    <div class="container is-fluid">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
    <toaster/>
    <dialogs-wrapper transition-name="fade"/>
  </main>
</template>

<style lang="scss">
  @import "./assets/scss/app";
</style>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters('auth', [
      'authenticated'
    ])
  }

}
</script>
